import axios from "axios";
import Config from "../config";
import RefreshTokenHandler from "../refreshToken/refreshToken";

export const getCaseByCaseId = async (email, case_id) => {
  try {
    const token = sessionStorage.getItem("token");
    const url = `${Config.baseUrl}/case/by-code?email=${email}&case_code=${case_id}`;
    const result = await axios.get(url, {
      headers: {
        Authorization: token || "",
      },
    });
    return result;
  } catch (err) {
    if (err.response.data.status === 401 || err.response.status === 403) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await getCaseByCaseId(email, case_id);
      } else {
        throw err;
      }
    } else {
      throw err;
    }
  }
};
